export default "__VITE_ASSET__DLWSNU7W__"